import { useHttpClient } from "@/common/api/httpClient";
import type { StorageAreaResponse } from "./models/storageAreaResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface ListStorageAreaResponse {
  ok: true;
  storageAreas: StorageAreaResponse[];
}

export function useListStorageAreas() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('storagearea'), {
      headers
    });

    const text = translations.value.storageAreas.actions.fetchMany;

    const response = await httpClient.action<ListStorageAreaResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as StorageAreaResponse[];
        return {
          ok: true,
          storageAreas: json
        };
      },
    });

    return response;
  }
}


